import React from "react";
import { Box, Grid, Stack, Typography, useMediaQuery } from "@mui/material";
import cardSideLine from "../../assets/icons/slide-side-dot-line.svg";
interface Props {
  slideNumber: string;
  slideAction: string;
  slideImg: string;
  slideText: string;
}

const sxStyles = {
  mainContainer: {
    display: "flex",
    flexDirection: "row",
    width: { xs: "250px", md: "" },
    paddingLeft: { xs: "30px", md: 0 },
    position: "relative",
  },
  imgContainer: {
    height: "auto",
    width: "295px",
    marginRight: "28.5px",
  },
  slideText: {
    color: "white",
    fontFamily: "IBM Plex Sans",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: "400",
    textAlign: "left",
    marginBottom: "40px",
  },
  titleFirstHalf: {
    color: "white",
    fontFamily: "p22-arts-and-crafts",
    fontSize: { xs: "42px", md: "64px" },
    lineHeight: { xs: "42px", md: "64px" },
    fontWeight: "700",
    marginBottom: "20px",
  },
  titleSecondHalf: {
    color: "white",
    fontFamily: "p22-arts-and-crafts",
    fontSize: { xs: "30px", md: "40px" },
    lineHeight: { xs: "40px", md: "64px" },
    fontWeight: "700",
    marginBottom: "20px",
  },
};

const CollectibleCard = (props: Props) => {
  const { slideNumber, slideImg, slideAction, slideText } = props;
  return (
    <Grid sx={sxStyles.mainContainer}>
      <Stack
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
          marginRight: { xs: "20px", md: "60px" },
        }}
      >
        <Typography sx={sxStyles.titleFirstHalf}>{slideNumber}</Typography>
        <Typography sx={sxStyles.titleSecondHalf}>{slideAction}</Typography>
        <Typography sx={sxStyles.slideText}>{slideText}</Typography>
        <Box sx={sxStyles.imgContainer}>
          <img src={slideImg} />
        </Box>
      </Stack>
      <Box
        sx={{
          position: "absolute",
          left: "380px",
          top: "0",
          height: "650px",
        }}
      >
        <img src={cardSideLine} />
      </Box>
    </Grid>
  );
};

export default CollectibleCard;
